import { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { toast } from "react-toastify";

const ShareMenu = ({ link, onShowQR }) => {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const btnRef = useRef(null);
  const menuRef = useRef(null);

  const handleToggle = (e) => {
    e.stopPropagation();
    if (!open && btnRef.current) {
      const r = btnRef.current.getBoundingClientRect();
      setPos({ top: r.top - 6, left: r.right }); // recalc on open
    }
    setOpen((p) => !p);
  };

  useEffect(() => {
    if (!open) return;
    const close = (e) => {
      if (
        btnRef.current?.contains(e.target) ||
        menuRef.current?.contains(e.target)
      )
        return;
      setOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      toast.success("Link copied");
    } catch {
      toast.error("Failed to copy");
    }
    setOpen(false);
  };

  const items = [
    {
      icon: "📷",
      label: "QR Code",
      action: () => {
        onShowQR();
        setOpen(false);
      },
    },
    {
      icon: "🔍",
      label: "View Link",
      action: () => {
        window.open(link, "_blank");
        setOpen(false);
      },
    },
    { icon: "📋", label: "Copy Link", action: handleCopy },
  ];

  return (
    <div style={{ display: "inline-flex" }}>
      <button
        ref={btnRef}
        className="jd-icon-btn"
        onClick={handleToggle}
        title="Share"
        style={{ fontSize: 13, width: "auto", padding: "0 10px", gap: 4 }}
      >
        🔗
      </button>

      {open &&
        createPortal(
          <div
            ref={menuRef}
            style={{
              position: "fixed",
              // anchor above-right of the button
              top: pos.top,
              left: pos.left,
              transform: "translate(-100%, -100%)",
              zIndex: 99999,
              background: "#fff",
              border: "1px solid #e5e7eb",
              borderRadius: 10,
              boxShadow: "0 8px 24px rgba(0,0,0,0.13)",
              minWidth: 148,
              overflow: "hidden",
            }}
          >
            {items.map(({ icon, label, action }) => (
              <button
                key={label}
                onClick={action}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  width: "100%",
                  padding: "9px 14px",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontSize: 13,
                  color: "#374151",
                  fontFamily: "inherit",
                  textAlign: "left",
                  transition: "background 0.1s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.background = "#f9fafb")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.background = "none")
                }
              >
                {icon} {label}
              </button>
            ))}
          </div>,
          document.body,
        )}
    </div>
  );
};

export default ShareMenu;
